export const AUTH_ERROR_MESSAGES: Record<string, string> = {
  Unauthorized: 'Wrong login or password',
  IncorrectAttemptsLocked: 'Account is locked due to incorrect attempts. Try again later.',
  UnknownError: 'The server is not responding. Please try again.',
  UserAlreadyExists: 'User already exists',
}
